import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { Step } from '@spark-web/vertical-stepper';
import { StepType } from '../../pages/ApplicationStatus/types';
import TextContent from './TextContent';

type StepProps = Exclude<StepType, 'key'>;

function StepComponent({ title, description, content, completed }: StepProps) {
  return (
    <Step>
      <Step.Heading title={title} renderStepNumber={() => ''} />
      {description && (
        <Step.Description>
          <Box paddingBottom="small">
            <Text tone="muted" size="small">
              {description}
            </Text>
          </Box>
        </Step.Description>
      )}
      <Step.Content>{content && <TextContent content={content} />}</Step.Content>
      <Step.CompletedContent>{completed && <TextContent content={completed} />}</Step.CompletedContent>
    </Step>
  );
}

export default StepComponent;
